import SpeakButton from "@/components/SpeakButton";
import { useState } from "react";
import { Star } from "lucide-react";
import { useT } from "@/i18n";
import { SAMPLE, PHOTO_TEXT } from "@/components/photo/content";

const CROSSES = [[33.3, 33.3], [66.6, 33.3], [33.3, 66.6], [66.6, 66.6]];

export default function RuleOfThirds() {
  const { lang } = useT();
  const tx = PHOTO_TEXT[lang];
  const [picked, setPicked] = useState(null);
  return (
    <div>
      <div className="flex flex-wrap items-center gap-2"><h3 className="font-fredoka text-xl sm:text-2xl font-bold text-blue-950">{tx.thirds}</h3><SpeakButton compact mascot="lumi" text={`${tx.thirds} ${tx.thirdsSub}`} testId="ask-photo-thirds" /></div>
      <p className="text-blue-900 font-semibold">{tx.thirdsSub}</p>
      <div className="mt-4 relative max-w-2xl rounded-3xl overflow-hidden border-4 border-white shadow-lg aspect-[3/2]" data-testid="thirds-grid">
        <img src={SAMPLE} alt="" className="absolute inset-0 w-full h-full object-cover" />
        {[33.3, 66.6].map((p) => (
          <div key={`v${p}`} className="absolute top-0 bottom-0 w-[3px] bg-white/90" style={{ left: `${p}%` }} />
        ))}
        {[33.3, 66.6].map((p) => (
          <div key={`h${p}`} className="absolute left-0 right-0 h-[3px] bg-white/90" style={{ top: `${p}%` }} />
        ))}
        {CROSSES.map(([x, y], i) => (
          <button
            key={i}
            type="button"
            onClick={() => setPicked(i)}
            className={`absolute -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full border-4 border-white flex items-center justify-center transition-transform hover:scale-110 ${picked === i ? "bg-yellow-300" : "bg-white/30"}`}
            style={{ left: `${x}%`, top: `${y}%` }}
            data-testid={`thirds-cross-${i}`}
            aria-label={`cross ${i + 1}`}
          >
            {picked === i && <Star className="w-6 h-6 text-blue-950 fill-blue-950" />}
          </button>
        ))}
      </div>
      <p className={`mt-3 inline-block rounded-full px-4 py-2 font-bold text-sm ${picked !== null ? "bg-lime-200 text-green-900" : "bg-white/80 text-blue-950"}`} data-testid="thirds-status">
        {picked !== null ? tx.thirdsOk : tx.thirdsTry}
      </p>
    </div>
  );
}
